export const CONTACT_PHONE = "+7 771 182 93 08";
export const CONTACT_PHONE_TEL = `tel:${CONTACT_PHONE.replace(/[\s-]/g, "")}`;
// The main contact number above isn't registered on WhatsApp — this
// separate number is, so WhatsApp links must build off it instead.
export const CONTACT_WHATSAPP_PHONE = "+7 916 716-91-77";
export const CONTACT_WHATSAPP_URL = `https://wa.me/${CONTACT_WHATSAPP_PHONE.replace(/\D/g, "")}`;
export const CONTACT_TELEGRAM_URL = "https://t.me/barcraft_ltd";
export const CONTACT_INSTAGRAM_URL = "https://www.instagram.com/barcraft.pro";
export const CONTACT_EMAIL = "toobarcraft@gmail.com";

export const CONTACT_BIN = "230440045149";
export const CONTACT_LEGAL_ADDRESS =
  "Республика Казахстан, г. Астана, район Алматы, ул. 101, здание 49Б, 010011";
